import { useRecoilState, useResetRecoilState } from "recoil";
import {
  mobileCurrentPage,
  mobileInputPage,
  mobilePageMove,
  pdfPage,
} from "../atoms";
import { useCallback, useEffect, useState } from "react";
import { IconButton, TextField, Tooltip, useMediaQuery } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import styled from "styled-components";
import usePageNavigation from "./useMobilePageNavigation";

function MobilePageButton() {
  const {
    currentPage,
    numPages,
    inputValue,
    moveToPage,
    setInputValue,
    setCurrenPage,
    setNumPages,
  } = usePageNavigation();

  const handleKeyPageMove = useCallback(
    (e) => {
      if (e.key === "ArrowRight") {
        e.preventDefault();
        moveToPage("next");
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        moveToPage("prev");
      }
    },
    [moveToPage]
  );
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPageMove);
    return () => {
      window.removeEventListener("keydown", handleKeyPageMove);
    };
  }, [handleKeyPageMove]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 엔터키 눌렀을 때 새로고침 방지
      const stringToNumber = Number(inputValue);
      if (stringToNumber === 0 || stringToNumber < 0) {
        alert("첫페이지로 이동합니다.");
        setCurrenPage(1);
        setInputValue(1);
        return;
      }
      if (stringToNumber > numPages) {
        alert(`마지막 페이지는 ${numPages}입니다.`);
        setCurrenPage(numPages);
        setInputValue(numPages);
        return;
      } else {
        setCurrenPage(stringToNumber);
      }
      e.target.blur(); // 키보드 닫기
    }
  };

  return (
    <div>
      <Tooltip title="Home" color="primary" onClick={() => moveToPage("home")}>
        <IconButton disabled={inputValue <= 1} sx={{ marginRight: 2 }}>
          <KeyboardDoubleArrowLeftIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Prev" color="primary" onClick={() => moveToPage("prev")}>
        <IconButton disabled={inputValue <= 1} sx={{ marginRight: 2 }}>
          <KeyboardArrowLeftIcon />
        </IconButton>
      </Tooltip>
      <TextField
        id="outlined-number"
        label="Page"
        type="number"
        size="small"
        value={inputValue}
        onKeyDown={handleKeyDown} // 엔터키 이벤트를 처리
        onChange={(e) => setInputValue(e.target.value)}
        sx={{ width: "70px", marginRight: 1 }}
      />
      <span> / </span>
      <span style={{ marginRight: "20px", marginLeft: "10px" }}>
        {numPages}
      </span>
      <Tooltip title="Next" color="primary" onClick={() => moveToPage("next")}>
        <IconButton disabled={inputValue >= numPages} sx={{ marginRight: 2 }}>
          <KeyboardArrowRightIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="End" color="primary" onClick={() => moveToPage("end")}>
        <IconButton disabled={inputValue >= numPages}>
          <KeyboardDoubleArrowRightIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default MobilePageButton;
